import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ManufacturerTableAction } from "stores/ManufacturerStore/ManufacturerAction";

const mapStateToProps = (state) => {
  return {
    AddManufacturer: state.manufacturer.AddManufacturer,
    AddManufacturerTable: state.manufacturer.AddManufacturerTable,
    isloadingAManufacturerTable: state.manufacturer.AManufacturerTable,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAddManufacturerAction: ManufacturerTableAction.getAddManufacturer,
      postAddManufacturerAction: ManufacturerTableAction.postAddManufacturer,
      AddVehicleManufactureEnableDisableAction:
        ManufacturerTableAction.AddVehicleManufactureEnableDisable,
      UdateManufacturerAction: ManufacturerTableAction.UdateManufacturerAction,
    },
    dispatch
  );

const VehicleManufacturerStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VehicleManufacturerStore;
